
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...spaSearchEN]",
      function () {
        return require("private-next-pages/[...spaSearchEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...spaSearchEN]"])
      });
    }
  